
export { CollectionName } from "/codebuild/output/src2403136238/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"